import React, { Component } from 'react';
import Autosuggest from 'react-autosuggest';
import InputControl from 'components/InputControl';

import './SuggestControl.scss';

class SuggestControl extends Component {

    static propTypes = Autosuggest.propTypes;

    static defaultProps = Object.assign(Autosuggest.defaultProps, {
        theme: {
            container: 'SuggestControl',
            suggestionsList: 'SuggestControl__suggestions',
            suggestion: 'SuggestControl__suggestion',
            suggestionFocused: 'SuggestControl__suggestion--focused',
            suggestionsContainer: 'SuggestControl__suggestions-section',
            sectionTitle: 'SuggestControl__suggestions-section-name',
            sectionSuggestions: 'SuggestControl__suggestions-section-suggestions'
        }
    })

    renderInputComponent = (inputProps) => <InputControl {...inputProps}/>

    render() {
    	let _theme = this.props.theme;
    	if (this.props.className) {
    		_theme.root = 'SuggestControl ' + this.props.className;
    	}

        return (
            <Autosuggest
                renderInputComponent={this.renderInputComponent}
                theme={_theme}
                {...this.props}/>
        );
    }
}

export default SuggestControl;



// WEBPACK FOOTER //
// ./client/components/SuggestControl/SuggestControl.js